import React, { useState, useMemo } from 'react';
import ImageGallery from 'react-image-gallery';
import './TourGallery.scss';
import { getImageUrl, getThumbnailUrl } from '../../utils/imageAssets';

const TourGallery = () => {
    const [isGalleryOpen, setIsGalleryOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFullscreen, setIsFullscreen] = useState(false);

    const galleryItems = useMemo(() => [
        { 
            original: getImageUrl('/images/gallery/01.jpeg'),
            thumbnail: getThumbnailUrl('/images/gallery/01.jpeg'),
            caption: 'GIST 전경',
            description: 'GIST 전경'
        },
        { 
            original: getImageUrl('/images/gallery/001.jpg'),
            thumbnail: getThumbnailUrl('/images/gallery/001.jpg'),
            caption: '중앙도서관',
            description: 'GIST 중앙도서관 외부 전경'
        },
        { 
            original: getImageUrl('/images/gallery/02.jpeg'),
            thumbnail: getThumbnailUrl('/images/gallery/02.jpeg'),
            caption: '행정동',
            description: 'GIST 행정동 외부 전경'
        },
        { 
            original: getImageUrl('/images/gallery/03.jpeg'),
            thumbnail: getThumbnailUrl('/images/gallery/03.jpeg'),
            caption: '제2학생회관',
            description: 'GIST 제2학생회관 외부 전경'
        },
        { 
            original: getImageUrl('/images/gallery/04.jpeg'),
            thumbnail: getThumbnailUrl('/images/gallery/04.jpeg'),
            caption: '학사 기숙사',
            description: 'GIST 학사 기숙사 전경'
        },
    ], []);

    const handleImageClick = (index) => {
        setCurrentIndex(index);
        setIsGalleryOpen(true);
        // 갤러리가 열린 후 바로 풀스크린으로 전환
        setTimeout(() => {
            const fullscreenBtn = document.querySelector('.image-gallery-fullscreen-button');
            if (fullscreenBtn) {
                fullscreenBtn.click();
            }
        }, 100);
    };

    const handleGalleryClose = () => {
        setIsGalleryOpen(false);
        setIsFullscreen(false);
    };

    const handleScreenChange = (fullScreenElement) => {
        const isFullscreenMode = !!fullScreenElement;
        setIsFullscreen(isFullscreenMode);
        
        // 풀스크린에서 나올 때 모달도 함께 닫기
        if (!isFullscreenMode) {
            setTimeout(() => {
                setIsGalleryOpen(false);
            }, 100);
        }
    };

return (
    <section className="sec-tour-gallery">
    <div className="TourGallery">
        <div className="box-main">
        <h2 className="gallery-title">캠퍼스 갤러리</h2>
        <div className="box-gallery">
            {galleryItems.map((item, index) => (
            <div key={index} className="gallery-item" onClick={() => handleImageClick(index)}>
                <img src={item.thumbnail} alt={item.caption} className="gallery-image" loading="lazy" decoding="async" />
                <div className="gallery-caption">{item.caption}</div>
            </div>
            ))}
        </div>
        </div>
    </div>

    {/* React Image Gallery Modal */}
    {isGalleryOpen && (
        <div className="gallery-modal">
            <div className="gallery-modal-overlay" onClick={handleGalleryClose}></div>
            <div className="gallery-modal-content">
                <button className="gallery-close-btn" onClick={handleGalleryClose}>×</button>
                <ImageGallery
                    items={galleryItems}
                    lazyLoad={true}
                    startIndex={currentIndex}
                    showFullscreenButton={true}
                    showPlayButton={false}
                    showThumbnails={true}
                    showBullets={false}
                    autoPlay={false}
                    slideDuration={450}
                    slideInterval={3000}
                    onScreenChange={handleScreenChange}
                />
            </div>
        </div>
    )}
    </section>
);
};

export default TourGallery;
